import { Box, ScopedCssBaseline } from '@mui/material'
import type { FC, ReactNode } from 'react'

import HeaderAppBar, { headerAppBarHeight } from '@/components/UI/HeaderAppBar'

type Props = {
  loading?: boolean
  headerAppBarContent?: ReactNode
  pageContent?: ReactNode
  isNavigationDrawerOpen?: boolean
}

const getPageContentMinHeight = (hasHeaderAppBar: boolean): string => {
  if (hasHeaderAppBar) {
    return `calc(100vh - ${headerAppBarHeight}px)`
  }

  return `100vh`
}

const PageContainer: FC<Props> = ({
  loading = false,
  headerAppBarContent = null,
  pageContent,
  isNavigationDrawerOpen = false,
}) => (
  <ScopedCssBaseline>
    {headerAppBarContent !== null && (
      <HeaderAppBar
        loading={loading}
        content={headerAppBarContent}
        isNavigationDrawerOpen={isNavigationDrawerOpen}
      />
    )}
    <Box
      sx={theme => ({
        backgroundColor: theme.palette.grey[100],
        flexGrow: 1,
        minHeight: getPageContentMinHeight(headerAppBarContent !== undefined),
        overflow: 'auto',
      })}
    >
      {pageContent}
    </Box>
  </ScopedCssBaseline>
)

export default PageContainer
